import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { GroupedSection } from '@miq/catalog';
import { ControlConfigTuple, ControlValidatorPlugin } from '@records/controls/models/control-validator-plugin';

const __ReactivePropertyTypeValidatorSymbol = Symbol('__ReactivePropertyTypeValidator');

/**
 * Validation runs on record level (main form) and reviews if there is at least one usage
 * in it
 */
@Injectable({ providedIn: 'root' })
export class ReactivePropertyTypeValidatorService implements ControlValidatorPlugin<GroupedSection> {
  connect(controlConfig: ControlConfigTuple<GroupedSection>): void {
    const { control } = controlConfig;
    if (!control[__ReactivePropertyTypeValidatorSymbol]) {
      control.setValidators((rootFormGroup: UntypedFormGroup) => {
        const usagesFormArray = rootFormGroup.get('usages') as UntypedFormArray;
        return usagesFormArray.length > 0 ? null : { propertyTypeDataRequired: true };
      });
      control[__ReactivePropertyTypeValidatorSymbol] = true;
    }
  }
}
